import { useState } from 'react';
import styles from './UserHoverCard.module.css';

interface UserHoverCardProps {
  author: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    position?: string;
    avatar?: string;
  };
  children: React.ReactNode;
}

export function UserHoverCard({ author, children }: UserHoverCardProps) {
  const [isVisible, setIsVisible] = useState(false);

  const fullName = `${author.firstName} ${author.lastName}`;
  const isUnknownAuthor = author.id === 'unknown-author';

  return (
    <div 
      className={styles.hoverContainer}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      
      {isVisible && (
        <div className={styles.hoverCard}>
          <div className={styles.cardContent}>
            <div className={styles.authorInfo}>
              <img
                src={author.avatar || '/user-avatar.png'}
                alt={fullName}
                className={styles.avatar}
              />
              <div className={styles.textInfo}>
                <div className={styles.name}>
                  {isUnknownAuthor ? 'Unknown Author' : fullName}
                </div>
                {author.position && !isUnknownAuthor && (
                  <div className={styles.position}>
                    {author.position}
                  </div>
                )}
                {isUnknownAuthor && (
                  <div className={styles.position}>
                    Creator
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
